import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

const styles = () => ({
  root: {},
  field: {
    flexDirection: 'row',
  },
});

const Layout = ({
  className,
  classes,
}) => {
  const {
    resource,
  } = useMetaLayoutContext();

  const onChange = (attr) => async (value) => {
    resource.attr(attr, value);
  };

  return (
    <div
      className={classNames(className, classes.root)}
    >
      <MetaControlField
        attr={'updateAction'}
        onChange={onChange('shouldImportAccount')}
        color="primary"
        className={classes.field}
      />
    </div>
  );
};

Layout.defaultProps = {
  className: '',
};

Layout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
